import {StyleSheet} from 'react-native';

import {onyxLight} from '/theme/color/on.color';
import {azure, chestnut, pine, yellow} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {},
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: 34,
  },
  icon: {
    marginRight: 20,
  },
  text: {
    flex: 1,
  },
  low: {
    color: onyxLight,
  },
  info: {
    color: azure,
  },
  important: {
    color: yellow,
  },
  success: {
    color: pine,
  },
  error: {
    color: chestnut,
  },
});
